import React from 'react';
import { FaCheck } from 'react-icons/fa';
import {
  Card,
  CardTitle,
  CardInfo,
  CardLabel,
  SelectButton,
  LimitMessage,
  ObservationBadge,
  AbsenceDetailsBox,
  AbsenceDetailRow,
  AbsenceDetailLabel,
} from '../../style/ModalDesignacao.styles';
import { formatDateBR } from '../../utils/ModalDesignacao.utils';
import DisponibilidadeItem from './DisponibilidadeItem';

const PublicadorCard = ({
  publicadorData,
  ultimaDesignacao,
  limite,
  dispSemana,
  ausenciaAtiva,
  isSelected,
  isDisabledByMax,
  totalSelecionados,
  togglePublicador,
}) => {
  const disabled = Boolean(
    (limite && limite.atingido) || (dispSemana && !dispSemana.disponivel) || ausenciaAtiva || isDisabledByMax
  );

  const observacao = (publicadorData.usuario?.observacao || '').trim();

  const mensagem = limite?.atingido
    ? limite.mensagem
    : ausenciaAtiva
    ? `Publicador ausente${ausenciaAtiva.motivo ? ` (${ausenciaAtiva.motivo})` : ''}`
    : dispSemana && !dispSemana.disponivel
    ? dispSemana.mensagem
    : null;

  const handleClick = () => {
    if ((!disabled || isSelected) && togglePublicador) {
      togglePublicador(publicadorData.usuario);
    }
  };

  return (
    <Card>
      <CardTitle>
        {publicadorData.usuario.nome} (congregação{' '}
        {publicadorData.usuario.congregacao.nome})
      </CardTitle>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          marginBottom: '10px',
        }}
      >
        {publicadorData.disponibilidades.map((disp, dispIdx) => (
          <DisponibilidadeItem
            key={`${disp._id}-${dispIdx}`}
            disponibilidade={disp}
          />
        ))}
      </div>

      <CardInfo>
        <CardLabel>Data da última designação:</CardLabel>{' '}
        {formatDateBR(ultimaDesignacao)}
      </CardInfo>

      <CardInfo style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '8px', rowGap: '4px', alignItems: 'center' }}>
        <CardLabel>Observações:</CardLabel>
        {ausenciaAtiva ? (
          <>
            <ObservationBadge>Ausente</ObservationBadge>
            <div />
            <AbsenceDetailsBox>
              <AbsenceDetailRow>
                <AbsenceDetailLabel>Período:</AbsenceDetailLabel>
                <span>{formatDateBR(ausenciaAtiva.dataInicio)} - {formatDateBR(ausenciaAtiva.dataTermino)}</span>
              </AbsenceDetailRow>
              <AbsenceDetailRow>
                <AbsenceDetailLabel>Motivo:</AbsenceDetailLabel>
                <span>{ausenciaAtiva.motivo}</span>
              </AbsenceDetailRow>
              {!ausenciaAtiva.todoODia && ausenciaAtiva.horarioInicio && ausenciaAtiva.horarioTermino && (
                <AbsenceDetailRow>
                  <AbsenceDetailLabel>Horário:</AbsenceDetailLabel>
                  <span>{ausenciaAtiva.horarioInicio} - {ausenciaAtiva.horarioTermino}</span>
                </AbsenceDetailRow>
              )}
            </AbsenceDetailsBox>
          </>
        ) : (
          <span style={{ gridColumn: '2 / span 1' }}>{observacao || 'Nenhuma observação'}</span>
        )}
      </CardInfo>

      {mensagem && <LimitMessage>{mensagem}</LimitMessage>}

      <SelectButton 
        disabled={disabled && !isSelected} 
        onClick={handleClick}
        style={{
          backgroundColor: isSelected ? '#007bff' : undefined,
          color: isSelected ? '#fff' : undefined,
          borderColor: isSelected ? '#007bff' : undefined,
        }}
      >
        {isSelected ? `Selecionado` : 'Selecionar'} <FaCheck style={{ fontSize: 10, marginLeft: 6 }} />
      </SelectButton>
    </Card>
  );
};

export default PublicadorCard;
